import { makeImmerReducer } from './utils';

/**
 * Keep track of global UI state.
 */
export interface UIState {
  /** True if the keyboard-shortcut-help modal should be shown. */
  showKeyboardShortcuts: boolean;
}

export const initialState: UIState = {
  showKeyboardShortcuts: false,
};

export const uiStateReducer = makeImmerReducer(initialState, (draft, action) => {
  switch (action.type) {
    case 'TOGGLE_SHOW_KEYBOARD_SHORTCUTS':
      draft.showKeyboardShortcuts = action.show;
      break;
  }
});
